import React from 'react';
import { Link } from 'react-router-dom';
import LegalPage, { LegalSection, PLATFORM_URL } from '../components/LegalPage';
import { BRAND } from '../config/brand';

const TermsPage = () => {
  return (
    <LegalPage title="Termini e Condizioni d'uso del servizio">
      <LegalSection title="1. Premesse e definizioni">
        <p>
          Il presente documento disciplina i termini e le condizioni di utilizzo di {BRAND.productName},
          il motore di ricerca di gare d&apos;appalto (di seguito, il &ldquo;Servizio&rdquo;) messo a
          disposizione da {BRAND.legalName}, con sede legale in {BRAND.address}, Partita IVA{' '}
          {BRAND.vatNumber} (di seguito, &ldquo;{BRAND.companyName}&rdquo; o il &ldquo;Titolare&rdquo;),
          accessibile tramite la piattaforma digitale disponibile all&apos;indirizzo {PLATFORM_URL} (la
          &ldquo;Piattaforma&rdquo;).
        </p>
        <p>
          Il Servizio &egrave; finalizzato esclusivamente a facilitare la ricerca, la consultazione e il
          monitoraggio di bandi di gara, avvisi e procedure di affidamento pubblicati su fonti pubbliche
          e istituzionali.
        </p>
        <p>
          La registrazione e l&apos;utilizzo del Servizio comportano l&apos;accettazione integrale dei
          presenti Termini e Condizioni. La <Link to="/privacy" className="underline">Privacy Policy</Link> e
          la <Link to="/cookie-policy" className="underline">Cookie Policy</Link> pubblicate sulla
          Piattaforma ne costituiscono parte integrante.
        </p>
      </LegalSection>

      <LegalSection title="2. Natura del Servizio e fonti delle informazioni">
        <p>Il Servizio ha carattere meramente informativo e di supporto.</p>
        <p>
          Le informazioni relative a gare, bandi e avvisi sono acquisite da fonti pubbliche e
          istituzionali, in particolare dalla piattaforma Pubblicit&agrave; Legale dell&apos;Autorit&agrave;
          Nazionale Anticorruzione (ANAC), e organizzate dal Titolare per agevolarne la ricerca.{' '}
          {BRAND.companyName} non esercita alcun controllo sulle fonti originarie e non garantisce la
          completezza, l&apos;esaustivit&agrave;, l&apos;accuratezza o l&apos;aggiornamento dei contenuti.
        </p>
        <p>
          Il Servizio non sostituisce la consultazione delle fonti originarie, che restano le uniche
          legalmente vincolanti ai fini della partecipazione alle procedure di gara.
        </p>
        <p>
          L&apos;uso del Servizio non costituisce attivit&agrave; di consulenza. Eventuali incarichi di
          assistenza professionale con {BRAND.companyName} sono regolati da accordi separati.
        </p>
      </LegalSection>

      <LegalSection title="3. Registrazione, account e livelli di accesso">
        <p>
          L&apos;accesso al Servizio &egrave; riservato agli utenti registrati. L&apos;utente si impegna a
          fornire informazioni veritiere, aggiornate e complete e a mantenerle aggiornate nel tempo.
        </p>
        <p>Il Servizio prevede due livelli di accesso:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>
            <strong>Guest</strong>: livello assegnato alla registrazione, che consente di utilizzare il
            motore di ricerca delle gare per un periodo di prova gratuito di 7 giorni. Il livello Guest
            non comprende l&apos;accesso ai link dei documenti di gara n&eacute; l&apos;invio automatico
            degli alert via email. Alla scadenza del periodo di prova l&apos;account viene disattivato e
            l&apos;utente ne riceve comunicazione via email;
          </li>
          <li>
            <strong>Associato</strong>: livello abilitato dal Titolare per gli utenti associati a{' '}
            {BRAND.companyName}, che consente l&apos;accesso a tutte le funzionalit&agrave; del Servizio,
            inclusi i link ai documenti di gara e gli alert email, nei limiti indicati in Piattaforma.
          </li>
        </ul>
        <p>
          L&apos;utente &egrave; responsabile della riservatezza delle proprie credenziali e di tutte le
          attivit&agrave; svolte tramite il proprio account. In caso di utilizzo non autorizzato o di
          violazione della sicurezza, l&apos;utente &egrave; tenuto a darne tempestiva comunicazione a{' '}
          {BRAND.companyName} scrivendo a {BRAND.privacyEmail}.
        </p>
      </LegalSection>

      <LegalSection title="4. Durata, sospensione e cessazione">
        <p>
          L&apos;utente pu&ograve; cessare l&apos;utilizzo del Servizio in qualsiasi momento e chiedere la
          cancellazione dell&apos;account scrivendo a {BRAND.privacyEmail}. {BRAND.companyName} pu&ograve;
          sospendere o disattivare l&apos;account, anche senza preavviso, in caso di violazione dei
          presenti Termini, utilizzo illecito del Servizio, esigenze di sicurezza o per adempiere a
          obblighi di legge o ordini dell&apos;Autorit&agrave;.
        </p>
        <p>
          Resta ferma la conservazione dei dati nei limiti e per i tempi indicati nella Privacy Policy.
        </p>
      </LegalSection>

      <LegalSection title="5. Alert, notifiche e personalizzazione del Servizio">
        <p>
          Gli utenti abilitati possono impostare alert email automatici relativi a gare di potenziale
          interesse, sulla base dei criteri selezionati (ad esempio codici CPV, categorie SOA, ambito
          territoriale, importi, parole chiave). Il numero di alert attivi e di invii giornalieri
          pu&ograve; essere limitato, secondo quanto indicato in Piattaforma.
        </p>
        <p>
          Gli alert sono generati automaticamente e hanno finalit&agrave; esclusivamente informativa.{' '}
          {BRAND.companyName} non garantisce che gli alert coprano tutte le gare potenzialmente rilevanti
          per l&apos;utente n&eacute; che siano privi di errori, omissioni o ritardi: l&apos;utente &egrave;
          tenuto a verificare sempre le informazioni presso le fonti ufficiali.
        </p>
        <p>
          L&apos;utente pu&ograve; modificare o disattivare gli alert in qualsiasi momento dalla propria
          area riservata. Gli alert non comportano decisioni automatizzate idonee a produrre effetti
          giuridici o analogamente significativi ai sensi dell&apos;art. 22 GDPR.
        </p>
      </LegalSection>

      <LegalSection title="6. Esclusione e limitazione di responsabilità">
        <p>{BRAND.companyName} non assume alcuna responsabilit&agrave; in merito a:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>errori, inesattezze, omissioni o incongruenze nei dati pubblicati dalle fonti;</li>
          <li>la mancata o tardiva pubblicazione di bandi, avvisi o informazioni rilevanti;</li>
          <li>l&apos;aggiornamento non tempestivo dei contenuti;</li>
          <li>l&apos;utilizzo delle informazioni da parte dell&apos;utente per finalit&agrave; decisionali, professionali o commerciali.</li>
        </ul>
        <p>
          Nei limiti consentiti dalla legge, {BRAND.companyName} non potr&agrave; essere ritenuta
          responsabile per danni diretti o indiretti, perdite di opportunit&agrave;, mancata
          partecipazione a gare, perdita di dati o altro pregiudizio derivante dall&apos;utilizzo del
          Servizio, salvi i casi di dolo o colpa grave.
        </p>
      </LegalSection>

      <LegalSection title="7. Continuità e funzionamento della Piattaforma">
        <p>
          {BRAND.companyName} adotta misure tecniche e organizzative ragionevoli per garantire il
          funzionamento e la sicurezza della Piattaforma, ma non ne garantisce la disponibilit&agrave;
          ininterrotta o l&apos;assenza di errori. Il Titolare non risponde di malfunzionamenti,
          interruzioni o indisponibilit&agrave; temporanee dovute a manutenzione, aggiornamenti, cause
          tecniche, eventi di forza maggiore o fatti di terzi, incluse le indisponibilit&agrave; delle
          fonti pubbliche.
        </p>
      </LegalSection>

      <LegalSection title="8. Divieti di utilizzo dei dati e dei contenuti">
        <p>
          &Egrave; vietato estrarre o riutilizzare in modo sistematico, massivo o automatizzato (anche
          tramite scraping, data mining o raccolta automatizzata) i dati e i contenuti del Servizio,
          nonch&eacute; riprodurre, distribuire o mettere a disposizione di terzi il database,
          l&apos;organizzazione dei contenuti o le funzionalit&agrave; della Piattaforma, salvo
          autorizzazione scritta di {BRAND.companyName}. &Egrave; altres&igrave; vietato condividere le
          proprie credenziali con terzi.
        </p>
        <p>
          &Egrave; consentito l&apos;utilizzo puntuale delle informazioni visualizzate per le ordinarie
          finalit&agrave; informative e operative dell&apos;utente, fermo l&apos;obbligo di verifica presso
          le fonti ufficiali. La violazione dei presenti divieti pu&ograve; comportare l&apos;immediata
          sospensione o cessazione dell&apos;accesso, ferma ogni ulteriore azione a tutela dei diritti
          del Titolare.
        </p>
      </LegalSection>

      <LegalSection title="9. Proprietà intellettuale">
        <p>
          La Piattaforma, la struttura del motore di ricerca, l&apos;organizzazione dei contenuti, il
          database, il software, il marchio {BRAND.companyName} e ogni altro segno distintivo sono di
          titolarit&agrave; del Titolare o dei rispettivi aventi diritto e sono protetti dalla normativa
          in materia di propriet&agrave; intellettuale e industriale. L&apos;utente non acquisisce alcun
          diritto su di essi, salvo il diritto di utilizzo del Servizio nei limiti dei presenti Termini.
        </p>
        <p>
          I contenuti degli avvisi di gara restano riconducibili alle rispettive fonti pubbliche.
        </p>
      </LegalSection>

      <LegalSection title="10. Trattamento dei dati personali">
        <p>
          Il trattamento dei dati personali degli utenti avviene nel rispetto del Regolamento (UE)
          2016/679 (GDPR) e della normativa applicabile, come descritto nella Privacy Policy e nella
          Cookie Policy. Le comunicazioni di servizio (incluse quelle tecniche e di sicurezza) sono
          inviate all&apos;indirizzo email associato all&apos;account; la Newsletter {BRAND.companyName}{' '}
          &egrave; inviata solo previo consenso.
        </p>
      </LegalSection>

      <LegalSection title="11. Modifiche al Servizio e ai Termini e Condizioni">
        <p>
          {BRAND.companyName} si riserva il diritto di modificare il Servizio e i presenti Termini e
          Condizioni. Le modifiche sono efficaci dalla data di pubblicazione sulla Piattaforma e, se
          sostanziali, sono comunicate agli utenti registrati. L&apos;utilizzo del Servizio successivo
          alla pubblicazione comporta l&apos;accettazione delle modifiche.
        </p>
      </LegalSection>

      <LegalSection title="12. Legge applicabile e foro competente">
        <p>
          I presenti Termini e Condizioni sono regolati dalla legge italiana. Per ogni controversia
          relativa alla loro interpretazione, esecuzione o validit&agrave; &egrave; competente in via
          esclusiva il Foro di Santa Maria Capua Vetere, salvo il foro inderogabile del consumatore
          qualora l&apos;utente rivesta tale qualifica.
        </p>
      </LegalSection>
    </LegalPage>
  );
};

export default TermsPage;
